export default __webpack_public_path__ + "static/media/Hotels.846ac8e0.svg";